<template>
  <div>
    <v-form ref="form" @submit.prevent="submit">
      <v-card outlined>
        <v-tabs v-model="tab" grow>
          <v-tab v-for="lang in tenant.languages" :key="'langtab-' + lang.code">
            <img :src="lang.icon" style="max-height: 20px" />
            &nbsp;&nbsp;{{ lang.name }}
            &nbsp;
            <v-icon
              v-if="langOk(translations, lang.code, ['feedback_policy'])"
              color="success"
            >
              {{ icons.mdiCheck }}
            </v-icon>
            <v-icon v-else color="error">{{ icons.mdiBlockHelper }}</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="lang in tenant.languages"
            :key="'langtabitem-' + lang.code"
          >
            <div style="padding: 20px">
              <v-textarea
                outlined
                rows="10"
                v-model="translations[lang.code].feedback_policy"
                :placeholder="$t('Miten palautteet käsitellään')"
                :label="$t('Miten palautteet käsitellään')"
              />
            </div>
          </v-tab-item>
        </v-tabs-items>
        <v-input
          class="ml-4 mb-4"
          hidden
          hide-details="auto"
          :rules="[validateLangs]"
        ></v-input>
      </v-card>
      <br />
      <v-btn type="submit" color="primary">
        {{ $t("Tallenna") }}&nbsp;&nbsp;
      </v-btn>
      <v-progress-circular
        v-if="isLoading"
        indeterminate
        size="18"
        :width="2"
        color="white"
      ></v-progress-circular>
      <v-icon size="32" color="success" class="ml-4" v-if="saved">
        {{ icons.mdiCheck }}
      </v-icon>
    </v-form>
  </div>
</template>

<script>
import {
  getValidTranslations,
  langOk,
} from "@/@core/utils/translation_helpers";
import useAuth from "@/useAuth";
import { onMounted, ref } from "@vue/composition-api";
import { mdiCheck, mdiBlockHelper } from "@mdi/js";
import adminApi from "@/api/admin";
import { useTranslations } from "@/@core/libs/i18n";
import { i18n } from "@/plugins/i18n";

export default {
  setup() {
    const tab = ref(null);
    const { tenant } = useAuth();
    const translations = ref({});
    const isLoading = ref(false);
    const form = ref(null);
    const saved = ref(false);

    tenant.value.languages.forEach((lang) => {
      translations.value[lang.code] = {
        feedback_policy: "",
      };
    });

    const fetchPolicy = async () => {
      isLoading.value = true;
      const response = await adminApi.getFeedbackPolicy();
      if (response.ok) {
        const t = {};
        tenant.value.languages.forEach((lang) => {
          if (response.data.translations[lang.code]) {
            t[lang.code] = response.data.translations[lang.code];
          } else {
            t[lang.code] = {
              feedback_policy: "",
            };
          }
        });

        translations.value = t;
      } else {
        alert(response.error);
      }
      isLoading.value = false;
    };

    const submit = async () => {
      if (form.value.validate()) {
        const payload = {
          translations: getValidTranslations(translations.value, [
            "feedback_policy",
          ]),
        };
        isLoading.value = true;
        const response = await adminApi.saveFeedbackPolicy(payload);
        if (response.ok) {
        }
        isLoading.value = false;
        saved.value = true;
        setTimeout(() => {
          saved.value = false;
        }, 3000);
      }
    };

    const validateLangs = (v) => {
      let valid = false;
      tenant.value.languages.forEach((lang) => {
        if (langOk(translations.value, lang.code, ["feedback_policy"]))
          valid = true;
      });

      if (valid) {
        return true;
      } else {
        return i18n.t("Tämä tieto on pakollinen");
      }
    };

    onMounted(() => {
      fetchPolicy();
    });

    return {
      form,
      translations,
      tenant,
      submit,
      isLoading,
      tab,
      saved,
      langOk,
      validateLangs,
      icons: {
        mdiCheck,
        mdiBlockHelper,
      },
    };
  },
};
</script>

<style>
</style>